export const SET_NOTIFICATION_MESSAGE = 'SET_NOTIFICATION_MESSAGE'

export const setNotificationMessage = (payload) => ({
  type: SET_NOTIFICATION_MESSAGE,
  payload,
})

export const CLEAR_NOTIFICATION_MESSAGE = 'CLEAR_NOTIFICATION_MESSAGE'

export const clearNotificationMessage = () => ({
  type: CLEAR_NOTIFICATION_MESSAGE,
})
